import { useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';
import { useEffectOnce } from 'react-use';

import { dashboardApi } from 'apis/dashboard';
import { websocketActions } from 'app/middleware/websocket/actions/websocket';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppPathParams } from 'utils/url/useAppPathParams';

import { TvDashboardViewOutletContext } from '../../tvDashboard.view';
import { useTvDashboardReloadEffect } from '../../utils/useTvDashboardReloadEffect';

import { TvFavoriteDashboardMetrics } from './components/metrics/tvFavoriteDashboardMetrics';

export const TvFavoriteDashboardView = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const { id } = useAppPathParams('/tv/dashboard/favorites/:id');
  const { setTitle } = useOutletContext<TvDashboardViewOutletContext>();

  const { favorite, queueIds, isLoading } =
    dashboardApi.useReadDashboardFavoriteQuery(
      { id },
      {
        selectFromResult: ({ data, ...rest }) => ({
          ...rest,
          favorite: data?.data.favorite,
          queueIds: data?.data.favorite.params.queue_ids ?? [],
        }),
      },
    );

  useEffect(() => {
    if (favorite) {
      setTitle(favorite.name);
    }
  }, [favorite, setTitle]);

  useEffectOnce(() => {
    setTitle(favorite?.name ?? 'Favorite');

    dispatch(
      websocketActions.request({
        type: 'connection:subscribe',
        params: {
          type: 'real_time_dashboard',
          dashboard_type: 'queue',
        },
      }),
    );

    return () => {
      dispatch(
        websocketActions.request({
          type: 'connection:unsubscribe',
          params: {
            type: 'real_time_dashboard',
            dashboard_type: 'queue',
          },
        }),
      );
    };
  });

  useTvDashboardReloadEffect('favorite');

  return (
    <TvFavoriteDashboardMetrics queueIds={queueIds} isLoading={isLoading} />
  );
};
